import { assertNever } from 'owa-assert';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getOfficeOnlineAppFromExtension,
    getExtensionFromFileName,
    OfficeOnlineApp,
} from 'owa-file';
import loc from 'owa-localize';
import { trace } from 'owa-trace';
import {
    EditInExcel,
    EditInOneDrive,
    EditInPowerPoint,
    EditInWord,
    EditOnline,
    ViewInOneDrive,
} from './getSecondLineSavedToCloudInfo.locstring.json';

export function getSecondLineSavedToCloudInfo(fileName: string): string {
    if (isFeatureEnabled('woven-saveToCloud2-viewInOneDrive')) {
        return loc(ViewInOneDrive);
    } else if (isFeatureEnabled('woven-saveToCloud2-editInOneDrive')) {
        return loc(EditInOneDrive);
    } else if (isFeatureEnabled('woven-saveToCloud2-editInApp')) {
        return getStringFromFileName(fileName);
    } else if (isFeatureEnabled('woven-saveToCloud2-editOnline')) {
        return loc(EditOnline);
    } else if (isFeatureEnabled('woven-saveToCloud2-openFolder')) {
        return loc(ViewInOneDrive);
    }

    return loc(EditOnline);
}

function getStringFromFileName(fileName: string): string {
    const extension: string = getExtensionFromFileName(fileName) || '';
    const officeApp = getOfficeOnlineAppFromExtension(extension);
    if (officeApp === null) {
        trace.error('invalid office app for save to cloud experiment string');
        return loc(EditInOneDrive);
    }

    switch (officeApp) {
        case OfficeOnlineApp.Word:
            return loc(EditInWord);
        case OfficeOnlineApp.Excel:
            return loc(EditInExcel);
        case OfficeOnlineApp.PowerPoint:
            return loc(EditInPowerPoint);
        default:
            return assertNever(officeApp);
    }
}
